"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Typography_1 = require("@material-ui/core/Typography");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var react_router_1 = require("react-router");
var ApolloClient_1 = require("src/ApolloClient");
var Snackbar_1 = require("src/Snackbar");
var ProductShow_1 = require("./ProductShow");
var UserCart_1 = require("src/bookstore/UserCart/UserCart");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var globalTypes_1 = require("src/schemaTypes/globalTypes");
var ProductShowPageGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nquery ProductShowSearch ($searchParameters: BookSearchParametersInput! $imageStyle: BookImageStyle){\n  searchBooks (searchParameters: $searchParameters) {\n    ...ProductShowFragment\n  }\n}\n", "\n"], ["\nquery ProductShowSearch ($searchParameters: BookSearchParametersInput! $imageStyle: BookImageStyle){\n  searchBooks (searchParameters: $searchParameters) {\n    ...ProductShowFragment\n  }\n}\n", "\n"])), ProductShow_1.ProductShowFragmentGQL);
var AddToCartGQL = graphql_tag_1.default(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\nmutation AddToCartMutation($itemParameters: CartItemParametersInput!) {\n  addItemToCart(itemParameters: $itemParameters ) {\n    cart { orderId }\n  }\n}\n"], ["\nmutation AddToCartMutation($itemParameters: CartItemParametersInput!) {\n  addItemToCart(itemParameters: $itemParameters ) {\n    cart { orderId }\n  }\n}\n"])));
var ProductShowPage = /** @class */ (function (_super) {
    __extends(ProductShowPage, _super);
    function ProductShowPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            variantBeingPurchased: undefined
        };
        _this.onAddClickFn = function (variantId, type) { return function (_event) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.setState({ variantBeingPurchased: type });
                        return [4 /*yield*/, ApolloClient_1.apolloClient.mutate({
                                mutation: AddToCartGQL,
                                variables: {
                                    itemParameters: { variantId: variantId }
                                }
                            })];
                    case 1:
                        _a.sent();
                        this.setState({ variantBeingPurchased: undefined });
                        this.props.userCart.refetch();
                        this.props.history.push('/cart/');
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.props.displayMessage(e_1.message, 'error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }; };
        return _this;
    }
    ProductShowPage.prototype.render = function () {
        var _this = this;
        var match = this.props.match;
        if (!match || !match.params || !match.params.slug) {
            return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: "Book Slug not recieved by page, cannot render" });
        }
        var productSlug = match.params.slug;
        return (React.createElement(react_apollo_1.Query, { query: ProductShowPageGQL, variables: { searchParameters: { productSlugs: [productSlug] }, imageStyle: globalTypes_1.BookImageStyle.PRODUCT } }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading) {
                return React.createElement(Typography_1.default, { variant: "h3" }, "Loading Product...");
            }
            if (error) {
                return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: error.message });
            }
            if (!data) {
                return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: "No Data Recieved" });
            }
            var book = data.searchBooks[0];
            if (!book) {
                return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: "No Data Recieved" });
            }
            return (React.createElement(ProductShow_1.default, { variantBeingPurchased: _this.state.variantBeingPurchased, onAddClickFn: _this.onAddClickFn, book: book }));
        }));
    };
    return ProductShowPage;
}(React.Component));
var DecoratedPage = UserCart_1.withUserCart(ErrorBoundary_1.withDisplayMessage(ProductShowPage));
exports.default = react_router_1.withRouter(DecoratedPage);
var templateObject_1, templateObject_2;
